"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TileItem = void 0;

var react_1 = __importDefault(require("react"));

var elements_1 = require("../../elements");

var TileItem = function TileItem(_a) {
  var headline = _a.headline,
      description = _a.description,
      date = _a.date,
      link = _a.link,
      bgImage = _a.bgImage,
      theme = _a.theme;
  var style = "table-cell rounded-lg border-2 shadow-md hover:shadow-lg " + (theme ? theme.body.backgroundColor : 'bg-gray-100') + " " + (theme ? theme.body.textColor : 'text-gray-800') + " " + (theme ? theme.body.borderColor : 'border-gray-400') + " p-4 mb-8 ml-4 mr-4";
  return react_1["default"].createElement("a", {
    href: link,
    className: style,
    style: {
      backgroundImage: "linear-gradient(to bottom, #0b3536 0%, rgba(125, 185, 232, 0)), url(" + bgImage + ")",
      backgroundSize: 'cover'
    }
  }, react_1["default"].createElement("div", {
    className: "flex flex-row justify-between"
  }, react_1["default"].createElement(elements_1.TitleSub, {
    theme: theme
  }, headline), react_1["default"].createElement(elements_1.Comment, {
    theme: theme
  }, date)), react_1["default"].createElement(elements_1.TextRegular, {
    theme: theme
  }, description));
};

exports.TileItem = TileItem;